import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import BookingDetails from "../MyBooking/components/BookingDetails";
import BookingStatus from "../MyBooking/components/BookingStatus";
import GuestInfo from "../MyBooking/components/GuestInfo";
import PaymentInfo from "../MyBooking/components/PaymentInfo";
import TourDetails from "../MyBooking/components/TourDetails";
import axiosInstance from "../../services/axiosInstance";

const BookingInfo: React.FC = () => {
  const [bookingData, setBookingData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { no } = useParams<{ no: string }>();
  const { t } = useTranslation();
  useEffect(() => {
    const fetchBookingData = async () => {
      try {
        const response = await axiosInstance.get(`/bookings/info?no=${no}`);
        // const response = await fetch(
        //   `http://98.83.31.160:8081/api/bookings/info?no=${no}`,
        // );
        console.log("response", response);
        if (response.status !== 200) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = response.data;
        setBookingData(data || {});
        setLoading(false);
      } catch (err) {
        setError((err as Error).message);
        setLoading(false);
      }
    };

    if (no) {
      fetchBookingData();
    }
  }, [no]); // Add dependency to ensure fetch is triggered when 'no' changes

  const formatPhoneNumber = (phoneNumber: string): string => {
    const cleaned = phoneNumber.replace(/\D/g, "");
    const countryCode = cleaned.substring(0, 2); // Country Code
    const areaCode = cleaned.substring(2, 5); // Area Code
    const firstPart = cleaned.substring(5, 9); // First 4 digits
    const secondPart = cleaned.substring(9, 13); // Last 4 digits

    return `+${countryCode} ${areaCode}-${firstPart}-${secondPart}`;
  };

  if (loading) return null;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="mx-auto max-w-[75rem] py-8">
      <div className="flex justify-center">
        <div className="flex h-[79rem] w-[46.25rem] flex-col gap-[1.875rem] rounded-[1.25rem] py-[1.875rem]">
          <div className="flex justify-between">
            <h1 className="decoration-skip-ink-auto text-left font-sans text-[1.5rem] font-semibold leading-[2.5rem]">
              {t("Booking Information")}
            </h1>
            {/* {bookingData?.orderStatus === "COMPLETED" && (
              <ButtonReceiveTicket countProduct={bookingData?.bookingResponse.qtyAdult + bookingData?.bookingResponse?.qtyChild} />
            )} */}
          </div>

          {/* Booking Status */}
          <BookingStatus bookingData={bookingData} />

          {/* Guest Info */}
          <GuestInfo
            guest={{
              name: `${bookingData?.nameCustomer}`,
              phone: formatPhoneNumber(bookingData?.phone || ""),
              email: bookingData?.emailCustomer || "",
            }}
          />

          {/* Tour Details */}
          <TourDetails
            tourTitle={
              bookingData?.bookingResponse.booking.product?.name || "N/A"
            }
            img={bookingData?.bookingResponse.booking.product?.thumbnail || ""}
            guests={[
              {
                guestNumber: bookingData?.bookingResponse?.qtyAdult || 0,
                type: "Adult",
                price: bookingData?.bookingResponse?.priceTotalAdult || 0,
              },
              {
                guestNumber: bookingData?.bookingResponse?.qtyChild || 0,
                type: "Child",
                price: bookingData?.bookingResponse?.priceTotalChild || 0,
              },
            ]}
          />

          {/* Booking Details */}
          <BookingDetails bookingData={bookingData} />

          {/* Payment Info */}
          <PaymentInfo
            guests={[
              {
                guestNumber: bookingData?.bookingResponse?.qtyAdult || 0,
                type: "Adult",
                price: bookingData?.bookingResponse?.priceTotalAdult || 0,
              },
              {
                guestNumber: bookingData?.bookingResponse?.qtyChild || 0,
                type: "Child",
                price: bookingData?.bookingResponse?.priceTotalChild || 0,
              },
            ]}
            additionalFee={bookingData?.paymentInfo?.additionalFee || 0}
            vatServiceCharge={bookingData?.paymentInfo?.vat || 0}
            payAmount={bookingData?.paymentInfo?.payAmount || 0}
          />
        </div>
      </div>
    </div>
  );
};

export default BookingInfo;
